import { Component, Input, OnInit } from '@angular/core';
import { AppService, GetMemberEnrollmentHistoryRequest, GetMemberEnrollmentHistoryResponse, MemberCCOEnrollment } from '../../app.service';
import { AlertService } from '../alert.service';
import { LoadingService } from '../loading.service';
import { catchError, finalize, map, Observable, of } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-member-enrollment-details',
  templateUrl: './member-enrollment-details.component.html',
  styleUrl: './member-enrollment-details.component.scss'
})
export class MemberEnrollmentDetailsComponent implements OnInit {

  @Input()
  public memberId: string;

  public enrollments: MemberCCOEnrollment[] = [];
  displayedColumns: string[] = ['rae', 'cco', 'enrollStatus', 'effectiveDate', 'termDate'];
  enrollmentsDataSource: MatTableDataSource<MemberCCOEnrollment> = new MatTableDataSource([]);


  constructor(
    private service: AppService,
    private alert: AlertService,
    private spinner: LoadingService,
  ) { }

  ngOnInit(): void {
    console.log(this.memberId);
    if (this.memberId) {
      this.getMemberEnrollment().subscribe(() => {

        this.enrollmentsDataSource.data = this.enrollments;

      });
      
    }
  }


  private getMemberEnrollment(): Observable<MemberCCOEnrollment[]> {
    const request = new GetMemberEnrollmentHistoryRequest();
    request.memberId = this.memberId;

    // Show the spinner before the request starts
    //this.spinner.show();

    return this.service.GetMemberEnrollmentHistory(request).pipe(
      map((result: GetMemberEnrollmentHistoryResponse) => {

        if (result.success) {

          console.log(result);
          this.enrollments = result.enrollments;
          
          //this.referralsDataSource = new MatTableDataSource(this.referrals);
          //this.referralsDataSource.data = this.referrals; // Update data property only


          //// Filter referrals based on the source or type property
          //const pcpReferrals = result.referrals.filter(r => r.referralType === 'PCP');
          //const hratReferrals = result.referrals.filter(r => r.referralType === 'HRAT');
          //const maternityReferrals = result.referrals.filter(r => r.referralType === 'Maternity');

          //// Debugging: Check the filtered lists
          //console.log('PCP Referrals:', pcpReferrals);
          //console.log('HRAT Referrals:', hratReferrals);
          //console.log('Maternity Referrals:', maternityReferrals);


          return result.enrollments; // Return the DCO array
        } else {
          console.log(`ERROR: ${result.message}`);
          return []; // Return an empty array in case of failure
        }
      }),
      catchError((error) => {
        console.error(error);
        return of([]); // Return an empty array or appropriate fallback in case of error
      }),
      finalize(() => {
        // Hide the spinner after the request completes
        //this.spinner.hide();
      })
    );
  }




}
